<script setup>
import { defineProps, defineEmits, watch, onBeforeUnmount } from 'vue'

const props = defineProps({
  show: { type: Boolean, default: false },
  message: { type: String, default: 'Fixture published successfully' },
  autocloseMs: { type: Number, default: 2500 }
})

const emit = defineEmits(['close'])

let timerId = null

watch(
  () => props.show,
  (visible) => {
    if (visible) {
      clearTimeout(timerId)
      timerId = setTimeout(() => emit('close'), props.autocloseMs)
    } else {
      clearTimeout(timerId)
    }
  },
  { immediate: true }
)

onBeforeUnmount(() => {
  clearTimeout(timerId)
})

const handleBackdropClick = (e) => {
  if (e.target === e.currentTarget) emit('close')
}
</script>

<template>
  <transition
    enter-active-class="transition duration-200 ease-out"
    enter-from-class="opacity-0"
    enter-to-class="opacity-100"
    leave-active-class="transition duration-150 ease-in"
    leave-from-class="opacity-100"
    leave-to-class="opacity-0"
  >
    <div
      v-if="show"
      class="fixed inset-0 z-[1100] bg-black/50 flex items-center justify-center p-6"
      @click="handleBackdropClick"
    >
      <div
        class="bg-white dark:bg-gray-900 rounded-xl shadow-2xl w-full max-w-sm p-6 text-center border border-gray-100 dark:border-gray-800"
        role="dialog"
        aria-live="polite"
      >
        <div class="mx-auto h-14 w-14 rounded-full bg-green-100 dark:bg-green-900/30 flex items-center justify-center mb-4">
          <i class="fas fa-check text-2xl text-green-600 dark:text-green-400"></i>
        </div>
        <h3 class="text-lg font-semibold text-gray-900 dark:text-white mb-1">
          Success
        </h3>
        <p class="text-gray-600 dark:text-gray-300">
          {{ message }}
        </p>
        <button
          type="button"
          class="mt-5 inline-flex items-center justify-center px-4 py-2 rounded-md bg-green-600 text-white text-sm font-medium hover:bg-green-700 focus:outline-none"
          @click="$emit('close')"
        >
          Close
        </button>
      </div>
    </div>
  </transition>
  
</template>

<style scoped>
</style>


